import { FC, PropsWithChildren } from 'react'

import { useVisualViewportLayout } from '@app/hooks/device'
import { useUserDevice } from '@app/hooks/useUserDevice'

export const AppLayoutOneColumn: FC<PropsWithChildren> = ({ children }) => {
  const { isMobileDevice } = useUserDevice()
  useVisualViewportLayout({ enabled: isMobileDevice })

  return (
    <div
      className={
        isMobileDevice
          ? 'fixed inset-x-0 top-[var(--visual-viewport-offset-top,0px)] z-0 grid h-[var(--visual-viewport-height,100dvh)] min-h-0 grid-cols-1 justify-center bg-background-default dark:bg-background-default-dark'
          : 'grid h-dvh min-h-0 grid-cols-1 justify-center bg-background-default not-supports-dvh:h-full dark:bg-background-default-dark'
      }
      data-testid="layout-one-column"
    >
      {children}
    </div>
  )
}
